<template>
  <aside
    class="sidebar sidebar-left"
    :style="{'padding-top': !$store.getters.showTopNavBar ? 0:''}"
  >
    <slot
      class="sidebar-left-top"
      name="sidebarLeftTop"
    >
    </slot>

    <nav-bar
      v-for="(navSection, index) in $store.state.site.content.navigation"
      :key="index"
      class="nav-bar"
      :nav-section="navSection"
    >
    </nav-bar>

    <slot
      class="sidebar-left-bottom"
      name="sidebarLeftBottom"
    >
    </slot>

    <slot
      class="sidebar-left-footer"
      name="sidebarLeftFooter"
    >
    </slot>
  </aside>
</template>

<script>

    import profileBlock from './profileblock.vue';
    import navBar from './navbar.vue';

    export default {
        name: 'left-nav-bar',
        methods: {
            closeMenu: function() {
                alert('close menu')
            },
            
        },

        data () {
            return {
                
            }
        }
        ,
        components: {
            profileBlock,
            navBar
        }
        ,
    }
</script>

<style>

</style>
